import React, {useEffect, useState} from 'react';

import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { coy } from 'react-syntax-highlighter/dist/esm/styles/prism';

const PHPExample = (props) => {
    const {method, url, data, headers, paramsType, changeCodeText, customStyle, secretKey} = props;
    const [codeText, setCodeText] = useState('');
    const getMethodNameToGetFormatData = () => {
        if(paramsType === 'json') {
            return 'json_encode($data)';
        } else if(paramsType === 'url') {
            return 'http_build_query($data)';
        }
    };

    const getHeadersArr = () => {
        let out = ['$headers = ['];
        for (let key in headers) {
            if (key == 'sign') {
                out.push(`\t"${key}: $sign"`);
            } else {
                out.push(`\t"${key}: ${headers[key]}",`);
            }
        }
        out.push("];");
        return out;

    };

    useEffect(() => {
        const {method, url, data, headers, paramsType, changeCodeText, customStyle} = props;
        const getDataCodeStrings = (data) => {
            if(method.toLowerCase() === 'get') return [];

            let out = ['$data = ['];
            for (let key in data) {
                if (key == "clientId") continue;
                out.push(`\t"${key}" => "${data[key]}",`);
            }
            out.push("];");
            return out;
        };
        const getUrl = (url) => {
            return url.replace(/users\/(.*)\/session/, 'users/${data[\'userId\']}/session');
        }
        

        let codeStrings = [
            '<?php',
            '',
            'function sortArray(array &$array)',
            '{',
            '\tksort($array);',
            '\t// Sort nested arrays, if any',
            '\tforeach ($array as $key => $value) {',
            '\t\tif (is_array($value)) {',
            '\t\t\tksort($array[$key]);',
            '\t\t}',
            '\t}',
            '}',
            '',
            'function generateSign($data, $SECRET_KEY): string',
            '{',
            '\t$paramsString = implode("", $data) . $SECRET_KEY;',
            '\treturn hash("sha256", $paramsString);',
            '}',
            '',
            `$SECRET_KEY = "${secretKey}";`,
            ...getDataCodeStrings(data),
            `$url = "${getUrl(url)}";`,
            '',
            'sortArray($data);',
            '',
            '$sign    = generateSign($data, $SECRET_KEY);',
            ...getHeadersArr(),
            '',
            '$options = array(',
            '\t"http" => array(',
            '\t\t"header"  => implode("\\r\\n", $headers) . "\\r\\n",',
            '\t\t"method"  => "POST",',
            '\t\t"content" => http_build_query($data)',
            '\t)',
            ');',
            '$context  = stream_context_create($options);',
            '$response = file_get_contents($url, false, $context);',
            ''
        ];
        const newCodeText = codeStrings.join('\n');
        setCodeText(newCodeText);
        changeCodeText(newCodeText);
    });




    return (
        <div className="php-example">
            <SyntaxHighlighter
                language="bash"
                style={coy}
                wrapLines={true}
                customStyle={customStyle}
            >
                {codeText}
            </SyntaxHighlighter>
        </div>
    );
}


export default PHPExample;